import { ConsiderationTreatment } from '../../pricing/models/consideration-treatment.enum';
import { TypeOfConsideration, isHeaderOnlyConsiderationType } from '../../pricing/models/type-of-consideration.enum';

export interface TypesOfConsiderationRow {
    considerationType: TypeOfConsideration;
    feePaymentTiming: ConsiderationTreatment | null;
    configuredTreatment: ConsiderationTreatment | null;
    projectedCashFlow: number | null;
    comment: string | null;
    isActive: boolean;
}

export interface HasConsiderationRows {
    considerationRows: TypesOfConsiderationRow[];
}

export const getConsiderationRow = (
    item: HasConsiderationRows,
    considerationType: TypeOfConsideration
): TypesOfConsiderationRow | undefined =>
    item.considerationRows.find((row) => row.considerationType === considerationType);

export const areActiveConsiderationRowsComplete = (
    rows: TypesOfConsiderationRow[]
): boolean =>
    rows
        .filter((row) => row.isActive && !isHeaderOnlyConsiderationType(row.considerationType))
        .every(
            (row) =>
                row.feePaymentTiming != null &&
                row.feePaymentTiming !== ConsiderationTreatment.Choice
        );
